import React from 'react';
import { apiFetch } from '../hooks/useApi';

export default function AdBanner({ ad }) {
  if (!ad) return null;

  const handleClick = async () => {
    try { await apiFetch(`/publicidade/${ad.id}/clique`, 'POST'); } catch {}
    if (ad.link_destino) window.open(ad.link_destino, '_blank', 'noopener noreferrer');
  };

  return (
    <div
      onClick={handleClick}
      style={{
        background: ad.cor_primaria || '#F97316',
        borderRadius: '14px',
        padding: '16px 18px',
        cursor: ad.link_destino ? 'pointer' : 'default',
        display: 'flex',
        alignItems: 'center',
        gap: '14px',
        position: 'relative',
        overflow: 'hidden',
        transition: 'transform 0.15s, box-shadow 0.15s',
        boxShadow: `0 4px 16px ${ad.cor_primaria || '#F97316'}40`,
        userSelect: 'none',
      }}
      onMouseEnter={e => {
        if (ad.link_destino) {
          e.currentTarget.style.transform = 'translateY(-2px)';
          e.currentTarget.style.boxShadow = `0 8px 24px ${ad.cor_primaria || '#F97316'}50`;
        }
      }}
      onMouseLeave={e => {
        e.currentTarget.style.transform = 'translateY(0)';
        e.currentTarget.style.boxShadow = `0 4px 16px ${ad.cor_primaria || '#F97316'}40`;
      }}
    >
      {/* Decorative circle */}
      <div style={{position:'absolute',right:'-20px',top:'-20px',width:'100px',height:'100px',borderRadius:'50%',background:'rgba(255,255,255,0.08)',pointerEvents:'none'}}/>

      {/* Image */}
      {ad.imagem_url && (
        <img src={ad.imagem_url} alt={ad.empresa}
          style={{width:'48px',height:'48px',borderRadius:'10px',objectFit:'cover',flexShrink:0,boxShadow:'0 2px 8px rgba(0,0,0,0.15)'}}
          onError={e=>e.target.style.display='none'} />
      )}

      {/* Text */}
      <div style={{flex:1,minWidth:0}}>
        <div style={{fontSize:'13px',fontWeight:'700',color:ad.cor_texto||'#fff',lineHeight:1.3}}>
          {ad.titulo}
        </div>
        {ad.subtitulo && (
          <div style={{fontSize:'11px',color:ad.cor_texto||'#fff',opacity:0.8,marginTop:'2px'}}>
            {ad.subtitulo}
          </div>
        )}
        <div style={{fontSize:'10px',color:ad.cor_texto||'#fff',opacity:0.5,marginTop:'3px'}}>
          Patrocinado · {ad.empresa}
        </div>
      </div>

      {/* CTA */}
      {ad.link_destino && (
        <div style={{
          background:'rgba(255,255,255,0.20)',
          borderRadius:'8px',padding:'6px 12px',
          fontSize:'11px',fontWeight:'700',
          color:ad.cor_texto||'#fff',
          flexShrink:0,whiteSpace:'nowrap',
        }}>
          Saiba mais →
        </div>
      )}
    </div>
  );
}
